import { NoteOutlineIcon } from '@carboncopyco/icons';
import type { Tag } from '@carboncopyco/types';
import { Button, ColorHex, InputText, TextBase } from '@carboncopyco/ui';
import { useClickAway } from '@uidotdev/usehooks';
import { useRef, useState } from 'react';
import { useWorkspaceManageTag } from './WorkspaceManageTagContext';

export const WorkspaceManageTagLabel = (props: Tag) => {
  const { updateTag, tags } = useWorkspaceManageTag();
  const inputRef = useRef<HTMLInputElement>();
  const [isEditable, setIsEditable] = useState(false);
  const [renameValue, setRenameValue] = useState<string>();
  const [alreadyExists, setAlreadyExists] = useState(false);
  const ref = useClickAway<HTMLInputElement>(() => {
    setIsEditable(false);
    setRenameValue(props.name);
    setAlreadyExists(false);
  });
  return (
    <div
      ref={ref}
      className="flex items-center justify-start"
    >
      <div
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          setIsEditable(false);
        }}
      >
        {isEditable ? (
          <div className="w-[380px] flex items-center">
            <InputText
              ref={inputRef}
              rightElement={
                alreadyExists && (
                  <NoteOutlineIcon
                    color={ColorHex.danger300}
                    size={20}
                  />
                )
              }
              state={alreadyExists ? 'error' : 'normal'}
              fullWidth
              showCharsCounter
              autoFocus
              onBlur={() => {
                setRenameValue(props.name);
                setAlreadyExists(false);
              }}
              onChange={(event) => {
                setRenameValue(event.target.value);
                const alreadyExists = tags.find(
                  (tag) => tag.name === event.target.value
                );

                if (alreadyExists) {
                  return setAlreadyExists(true);
                }

                setAlreadyExists(false);
              }}
              defaultValue={props.name}
              onKeyPress={(keypress) => {
                if (!alreadyExists && keypress.key === 'Enter') {
                  renameValue && updateTag(props.id, renameValue);
                  setIsEditable(false);
                  setRenameValue(props.name);
                  setAlreadyExists(false);
                }
              }}
            />
            <Button
              disabled={alreadyExists}
              label="Save"
              link
              onClick={() => {
                renameValue && updateTag(props.id, inputRef.current.value);
              }}
            />
          </div>
        ) : (
          <div
            className="truncate"
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              setIsEditable(true);
            }}
          >
            <TextBase
              label={props.name}
              color="text-ds-natural-600"
              verticalTextAlign="align-text-bottom"
            />
          </div>
        )}
      </div>
    </div>
  );
};
